"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobile_detect_1 = __importDefault(require("mobile-detect"));
const product_1 = require("./product");
exports.default = (userAgent, product) => {
    const uaInfo = new mobile_detect_1.default(userAgent || "");
    let device = "desktop";
    device = (uaInfo.mobile() && "mobile") || device;
    device = (uaInfo.tablet() && "tablet") || device;
    // tablet exception
    if (device === "desktop") {
        return product_1.PRODUCTS_MOBILE.includes(product || "") ? "tablet" : device;
    }
    return device;
};



// WEBPACK FOOTER //
// ./node_modules/@tvg/conf/cjs/src/device.js